/* eslint-disable react-hooks/rules-of-hooks */
import { Box, Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useParams, useSearchParams } from 'react-router-dom';

import CollectionItem from 'commons/Collection/CollectionItem';
import Loading from 'commons/Loading';
import PaginationCustom from 'commons/PaginationCustom';
import Text from 'commons/Text';
import API from 'configs/API';
import usePagination from 'hooks/usePagination';
import Routes from 'utils/Route';
import { useQueryParameters } from 'utils/utils';

import TabArtworkHeader from '../TabArtworkHeader';
import useStyles from './styles';

const ArtworkCollection = ({ isOwner, isPublicShare = false }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const query = useQueryParameters();
  const searchValue = query.get('search');

  const { id, uuid } = useParams();
  const [searchParams] = useSearchParams();
  const objectParamsFromSearchParams = Object.fromEntries(searchParams);

  const params = {
    ...objectParamsFromSearchParams,
  };
  if (isPublicShare) {
    params.share_link_id = uuid;
  } else {
    params.user_uuid = id;
  }

  let listCollection = [];
  let page = 1;
  let totalPage = 1;
  let onPageChange = () => {};

  const { data, isPending } = useQuery({
    queryKey: [API.ARTWORK.LIST_GALLERY_COLLECTION, params],
  });
  const {
    page: _page,
    totalPage: _totalPage,
    onPageChange: _onPageChange,
  } = usePagination(data?.count, data?.page_size);

  page = _page;
  totalPage = _totalPage;
  onPageChange = _onPageChange;
  listCollection = data?.results;

  if (isPending) {
    return <Loading />;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <TabArtworkHeader
        placeholder={t('search_by_title_collection_name')}
        isOwner={isOwner}
      />

      <Grid
        container
        spacing={5}
      >
        {listCollection?.length > 0
          ? listCollection.map((collection, index) => (
              // eslint-disable-next-line react/jsx-indent
              <Grid
                key={index}
                item
                xs={12}
                lg={3}
              >
                <CollectionItem
                  collection={collection}
                  isOwner={isOwner}
                  redirectTo={{
                    pathname: Routes.GalleryDetail(id),
                    search: createSearchParams({ tab: '2' }).toString(),
                  }}
                />
              </Grid>
            ))
          : null}
      </Grid>

      {searchValue && listCollection?.length === 0 && (
        <div className={classes.wrapTextNoResult}>
          <Text>{t('no_results_that_match_your_search')}</Text>
          <Text>{t('please_try_adjust_your_keywords')}</Text>
        </div>
      )}

      {!!totalPage && (
        <PaginationCustom
          paginationStyle={classes.pagination}
          count={totalPage}
          page={page}
          onChange={onPageChange}
        />
      )}
    </Box>
  );
};

export default ArtworkCollection;
